import { render, staticRenderFns } from "./SvgImage.vue?vue&type=template&id=9aab3db4&"
import script from "./SvgImage.ts?vue&type=script&lang=ts&"
export * from "./SvgImage.ts?vue&type=script&lang=ts&"
import style0 from "./SvgImage.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports